import React from 'react';
import styles from './formsBrowser.module.scss';
import { useTranslation } from 'react-i18next';
import { getSearchTermSuggestionCount } from './services/formsBrowserService';
import { Icon } from '../../components/icon/Icon';
import { FormProps, SearchProps, SelectionProps } from './types/FormTypes';

export const SearchTermSuggestions = React.memo(
    (props: { selectionProps: SelectionProps; searchProps: SearchProps }) => {
        const { t } = useTranslation();

        try {
            const {
                selectionProps: { handleOnFormSelect },
                searchProps: { searchTermSuggestions, searchTerm },
            } = props;

            const {
                searchTermSuggestionCount,
                searchTermSuggestionDisplayedCount,
            } = getSearchTermSuggestionCount(searchTermSuggestions);

            if (searchTerm !== '' && searchTermSuggestionCount) {
                return (
                    <div className={styles.searchTermSuggestionsContainer}>
                        <div
                            className={
                                styles.searchTermSuggestionCountContainer
                            }
                        >
                            {`${searchTermSuggestionDisplayedCount} / ${searchTermSuggestionCount} - ${t(
                                'FormsBrowser.SearchTermSuggestionDescription',
                            )}`}
                        </div>
                        {searchTermSuggestions
                            ?.map((suggestedForm: FormProps, index) => (
                                <button
                                    type="button"
                                    key={index}
                                    className={styles.suggestedFormContainer}
                                    onClick={() =>
                                        handleOnFormSelect(suggestedForm)
                                    }
                                    aria-label={t('FormsBrowser.SelectForm', 'Select form: {{title}}', { title: suggestedForm?.Title__c })}
                                >
                                    <span
                                        className={
                                            styles.suggestedFormIconContainer
                                        }
                                        aria-hidden="true"
                                    >
                                        <Icon
                                            icon="search"
                                            color="black"
                                            size="large"
                                        />
                                    </span>
                                    <span
                                        className={
                                            styles.suggestedFormTitleContainer
                                        }
                                    >
                                        {suggestedForm?.Title__c}
                                    </span>
                                </button>
                            ))
                            ?.slice(0, searchTermSuggestionDisplayedCount)}
                    </div>
                );
            } else if (searchTerm !== '' && !searchTermSuggestionCount) {
                return (
                    <div className={styles.searchTermSuggestionsContainer}>
                        <div className={styles.suggestedFormNoResultsContainer}>
                            <div className={styles.suggestedFormIconContainer}>
                                <Icon icon="ban" color="black" size="large" />
                            </div>
                            <div className={styles.suggestedFormTitleContainer}>
                                {t('FormsBrowser.SuggestionsNoResults')}
                            </div>
                        </div>
                    </div>
                );
            } else {
                return null;
            }
        } catch {
            return null;
        }
    },
);
